import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { useStyles } from './SlidesStyles'
import { getSearchByTRFData } from '../../actions'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import SuccesSnackBar from '../HOC/SuccesSnackBar'
import SearchIcon from '@mui/icons-material/Search'
import SearchTableComponent from '../CaseWorklist/Common/SearchTableComponent'
import { SearchColumns } from './table_def'

export function SearchTRFInput({ user, role }): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [trfId, setTRF] = useState('')
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const { re_search_success, re_search_error } = useSelector((state: RootState) => state.searchDataResponse)
  const searchData = useSelector((state: RootState) => state.addSearchData)
  const [onTrfSearch, setOnTrfSearch] = useState(false)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)

  const onTRFChange = (val) => {
    if (val.length < 3) {
      setOpenErrorSnackBar(false)
      setOpenSuccessSnackBar(false)
    }
    setTRF(val)
  }

  const onSearchEntry = async (event, val, user) => {
    const keyCode = event.keyCode ? event.keyCode : event.which
    if (keyCode === 13 || event.type === 'click') {
      if (val.length >= 3) {
        setOpenErrorSnackBar(false)
        setOnTrfSearch(true)
        await dispatch(
          getSearchByTRFData({
            user_id: user,
            trf_id: val,
            user_role: role,
          }),
        )
        setOpenSuccessSnackBar(true)
      } else {
        setOpenErrorSnackBar(true)
      }
    }
  }
  const ProcedureCodeRenderer = {
    field: 'procedure_code',
    headerName: 'Case Type',
    sortable: true,
    width: 200,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    valueGetter: (params) => {
      const procedureCodeResults = procedureData.procedureCodeMap.filter((value) => {
        return value.id == params.row.procedure_code
      })
      return procedureCodeResults[0]?.display
    },
  }
  SearchColumns.push(ProcedureCodeRenderer)
  useEffect(() => {
    setTimeout(() => setOpenErrorSnackBar(false), 1000)
  }, [openErrorSnackBar])
  return (
    <>
      {re_search_error && openSuccessSnackBar && <ErrorSnackBar message="Search failed" />}
      {openErrorSnackBar && <ErrorSnackBar message="Enter minimum 3 characters to perform search" />}
      {re_search_success && openSuccessSnackBar && <SuccesSnackBar message="Search completed successfully" />}
      <div>
        <p className={classes.searchTitle}>Search TRF cases </p>
        <div className={`${classes.searchBox}`}>
          <input
            className={`${classes.searchInput}`}
            placeholder="Enter TRF ID (Minimum 3 characters)"
            value={trfId}
            autoFocus
            onChange={(e) => onTRFChange(e.target.value)}
            type="text"
            onKeyDown={(e) => onSearchEntry(e, trfId, user)}
            maxLength={5}
          />
          <div className={`${classes.searchIconBox}`}>
            <SearchIcon className="WP_SearchIcon" onClick={(e) => onSearchEntry(e, trfId, user)} />
          </div>
        </div>
      </div>
      {onTrfSearch && searchData.data && (
        <div>
          <p className={classes.searchTitle}>Search results for &apos;{`${searchData.trfId}`}&apos; </p>
          <SearchTableComponent trf_id={trfId} />
        </div>
      )}
    </>
  )
}
